import { createSelector } from '@reduxjs/toolkit';
import { InboxesStoreStateI } from 'store/reducers/inboxes.reducer';

export const inboxesStoreStateSelector = (
  state,
): InboxesStoreStateI => state.inboxes;

export const inboxesSelector = createSelector(
  inboxesStoreStateSelector,
  (storeState) => ({
    isLoading: storeState.isLoading,
    inboxes: storeState.inboxAddresses.map(
      (address) => storeState.addressToDetailMap[address],
    ),
  }),
);

export const inboxesListSelector = createSelector(
  inboxesSelector,
  (inboxes) => inboxes?.inboxes || [],
);

export const hasInboxesSelector = createSelector(
  inboxesListSelector,
  (inboxes) => inboxes.length > 0,
);

export const dropdownInboxesSelector = createSelector(
  inboxesStoreStateSelector,
  ({
    inboxAddresses,
  }): {
    value: any;
    label: string;
  }[] =>
    inboxAddresses.map((address) => ({
      value: address,
      label: address,
    })),
);

export const loadingInboxesSelector = createSelector(
  inboxesStoreStateSelector,
  (inboxes) => inboxes.isLoading,
);

export const loadDataErrorInboxesSelector = createSelector(
  inboxesStoreStateSelector,
  (inboxes) => inboxes.error,
);

export const inboxesDataMapSelector = createSelector(
  inboxesStoreStateSelector,
  ({ addressToDetailMap }) => {
    return addressToDetailMap;
  },
);
